import { useState, forwardRef, useImperativeHandle } from 'react'
import { Upload } from 'antd'
import { CloseCircleFilled, PlusOutlined, FileFilled } from '@ant-design/icons'

import { message } from '@/App'
import styles from './index.module.less'

const fileTypeConfig = {
  pic: {
    accept: 'image/png, image/jpeg, image/jpg',
    name: '图片',
  },
  video: {
    accept: 'video/*',
    name: '视频',
    poster: '',
  },
  audio: {
    accept: 'audio/*',
    name: '音频',
  },
  scene: {
    accept: '.ply',
    name: '.ply文件',
  },
} as any

const ExampleFile = forwardRef(({ data }: any, ref) => {
  const [curSelected, setCurSelected] = useState<any>(null)
  const [file, setFile] = useState<any>(null)

  const getFileType = (file: File) => {
    if (file.type.match('image.*')) {
      return 'pic'
    }
    if (file.type.match('audio.*')) {
      return 'audio'
    }
    if (file.type.match('video.*')) {
      return 'video'
    }
    if (file.name.endsWith('.ply')) {
      return 'scene'
    }
    return 'unknown'
  }

  const validateFile = (file: File) => {
    const fileSize = file.size / 1024 / 1024
    const fileType = getFileType(file)
    // if (fileTypeConfig[data.file_type].accept.includes(file.type)) {
    //   message.error('文件格式暂不支持')
    //   return false
    // }
    if (fileType === 'pic' && fileSize > 5) {
      message.error('图片大小需5M以内')
      return false
    }
    if (fileType === 'audio' && fileSize > 20) {
      message.error('音频大小需20M以内')
      return false
    }
    if (fileType === 'video' && fileSize > 200) {
      message.error('视频大小需200M以内')
      return false
    }
    if (fileType === 'unknown') {
      message.error('文件格式暂不支持')
      return false
    }
    return true
  }

  const onFileChanged = async ({ file }: any) => {
    // const fileType = getFileType(file)
    if (!validateFile(file)) {
      return
    }
    if (data.file_type !== 'pic') {
      setCurSelected({
        file,
        poster:
          'https://zdtc-cdn.wair.ac.cn/20231219191948_input_svg_1702984788_ptP5a.svg',
        name: file.name,
      })
      setFile(file)
      return
    }
    const reader = new FileReader()
    reader.onload = async () => {
      const fileBlob = new Blob(
        [new Uint8Array(reader.result as ArrayBufferLike)],
        { type: file.type },
      )
      const fileUrl = URL.createObjectURL(fileBlob)
      file.url = fileUrl
      setCurSelected({
        file,
        poster: file.url,
        name: file.name,
      })
      setFile(file)
    }
    reader.readAsArrayBuffer(file)
    // reader.readAsDataURL(file)
  }

  useImperativeHandle(ref, () => ({
    curSelected,
    file,
  }))

  return (
    <>
      <div>
        <div className={styles.title}>选择文件：</div>
        <div className={styles.images}>
          <Upload
            accept={fileTypeConfig[data.file_type].accept}
            showUploadList={false}
            beforeUpload={() => false}
            onChange={onFileChanged}
          >
            {curSelected ? (
              <>
                <div className={`${styles.imageItem} ${styles.uploaded}`}>
                  <img
                    loading="lazy"
                    className="object-contain"
                    src={curSelected.poster || curSelected.url}
                  />
                  <CloseCircleFilled
                    onClick={e => {
                      e.stopPropagation()
                      setFile(null)
                      setCurSelected(null)
                    }}
                  />
                </div>
                <div className="text-center">{curSelected.name}</div>
              </>
            ) : (
              <div className={`${styles.imageItem} ${styles.upload}`}>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>{`上传${
                  fileTypeConfig[data.file_type].name
                }`}</div>
              </div>
            )}
          </Upload>
        </div>
      </div>
      <div>
        <div className={styles.title}>示例文件：</div>
        <div className={styles.images}>
          {data.files?.map((item: any, index: number) => (
            <div
              key={index}
              className={`${styles.imageItem} ${
                curSelected?.url === item.url ? styles.selected : ''
              }`}
              onClick={() => {
                setCurSelected({
                  ...item,
                  name: `示例${index + 1}`,
                })
              }}
            >
              <img
                loading="lazy"
                className="object-contain"
                src={item.poster || item.url}
                alt=""
              />
              <div className="text-center">{`示例${index + 1}`}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
})

export default ExampleFile
